const getKey = () => {
  const url = new URL(window.location.href);
  const path = url.pathname + url.search;
  return 'scroll-position[' + path + ']';
};

// Other scripts (e.g. content that still needs to lazy-load) can register a
// promise here to postpone the scroll restore until they have settled, so the
// page height is final before we scroll to a stored position.
//
// This base script itself is loaded asynchronously (see script-body.php's
// <script type="text/interactive"> swap), so a page's own inline script can
// easily run BEFORE window.util exists yet. A plain array on `window` works
// regardless of which side runs first: whichever runs first just creates it.
const getDeferredQueue = () => {
  if (!window.__ncScrollRestoreQueue) {
    window.__ncScrollRestoreQueue = [];
  }
  return window.__ncScrollRestoreQueue;
};
// A safety net only: normally the restore fires as soon as all deferred
// promises resolve, however long that actually takes. This cap just
// prevents an indefinite wait if something never resolves (e.g. a failed
// request).
const deferredTimeoutMs = 6000;
export const defer = promise => {
  getDeferredQueue().push(promise);
};
export const store = () => {
  // When the page is being unloaded store the scroll position.
  window.addEventListener('beforeunload', () => {
    sessionStorage.setItem(getKey(), window.scrollY);
  });
};
export const restore = async () => {
  const key = getKey();

  // Get the scroll position from the session storage.
  let scrollY = sessionStorage.getItem(key);
  const deferredPromises = getDeferredQueue();
  if (scrollY === null) {
    return;
  }
  scrollY = Number.parseFloat(scrollY);
  if (!scrollY) {
    return;
  }

  // Wait for any deferred work (e.g. lazy-loaded content) to settle first,
  // so the page height is final. Don't wait forever in case something
  // never resolves.
  if (deferredPromises.length > 0) {
    // If the visitor scrolls by themselves while we're still waiting,
    // they've taken over, so don't yank them back afterwards.
    const scrollKeys = ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '];
    let userScrolled = false;
    const onUserScroll = () => {
      userScrolled = true;
    };
    const onUserKeydown = event => {
      if (scrollKeys.includes(event.key)) {
        userScrolled = true;
      }
    };
    window.addEventListener('wheel', onUserScroll, {
      passive: true
    });
    window.addEventListener('touchmove', onUserScroll, {
      passive: true
    });
    window.addEventListener('keydown', onUserKeydown);
    const timeout = new Promise(resolve => setTimeout(resolve, deferredTimeoutMs));
    await Promise.race([Promise.all(deferredPromises), timeout]);
    window.removeEventListener('wheel', onUserScroll);
    window.removeEventListener('touchmove', onUserScroll);
    window.removeEventListener('keydown', onUserKeydown);
    if (userScrolled) {
      sessionStorage.removeItem(key);
      return;
    }
  }

  // Prevent the default browser behaviour.
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
  // Scroll the user to the section.
  window.scrollTo({
    top: scrollY,
    left: 0,
    behavior: 'instant'
  });

  // Clear again so the user doesn't keep scrolling to this section again.
  sessionStorage.removeItem(key);
};